// extracted by mini-css-extract-plugin
module.exports = {"franchiseDownloadBrochure":"_2bTAw"};